import { render } from "./FriendsPage.vue?vue&type=template&id=f300390c"
import script from "./FriendsPage.vue?vue&type=script&lang=js"
export * from "./FriendsPage.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "f300390c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f300390c', script)) {
    api.reload('f300390c', script)
  }
  
  module.hot.accept("./FriendsPage.vue?vue&type=template&id=f300390c", () => {
    api.rerender('f300390c', render)
  })

}

script.__file = "src/views/FriendsPage.vue"

export default script